import React, { useState } from 'react';
import { ArrowLeft, Share2, Check } from 'lucide-react';
import { ThemeToggle } from './ui/ThemeToggle';

/** Sticky bar shared by every project page: back, breadcrumb, share link and theme. */
export default function ProjectTopBar({ project, onBack, label }) {
  const [copied, setCopied] = useState(false);

  const handleCopyShare = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <header className="sticky top-0 z-50 h-14 bg-[var(--bg-canvas)] border-b border-[var(--bg-recessed)] shadow-[var(--header-line)] transition-colors">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-6 h-full flex items-center justify-between">
        <div className="flex min-w-0 items-center gap-2.5">
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-[var(--fg-secondary)] hover:text-[var(--fg-primary)] hover:bg-[var(--bg-hover)] transition-colors cursor-pointer"
          >
            <ArrowLeft size={14} />
            <span className="hidden sm:inline">Back to Portfolio</span>
            <span className="sm:hidden">Back</span>
          </button>

          <span className="text-[var(--fg-muted)]">/</span>

          <span className="t-mono text-xs text-[var(--fg-muted)] whitespace-nowrap">
            {label || `PROJECT #${String(project.id).padStart(2, '0')}`}
          </span>

          <span className="text-[var(--fg-muted)] hidden sm:inline">/</span>

          <span className="t-mono text-xs text-[var(--fg-primary)] font-medium truncate max-w-[140px] sm:max-w-[280px] hidden sm:inline">
            {project.title}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleCopyShare}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-[var(--fg-secondary)] hover:text-[var(--fg-primary)] hover:bg-[var(--bg-hover)] transition-colors cursor-pointer"
            title="Copy share link"
          >
            {copied ? (
              <>
                <Check size={13} className="text-[var(--accent)]" />
                <span className="hidden sm:inline text-[var(--accent)] font-medium">Copied!</span>
              </>
            ) : (
              <>
                <Share2 size={13} />
                <span className="hidden sm:inline">Share</span>
              </>
            )}
          </button>

          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
